(() => {
  'use strict';

  const soldOutText = () => window.WUB?.i18n?.product?.soldOut || '';
  const unavailableText = () => window.WUB?.i18n?.product?.unavailable || '';

  const optionBaseText = (option) => {
    if (option.dataset.wubBaseLabel) return option.dataset.wubBaseLabel;
    const soldOut = soldOutText().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const unavailable = unavailableText().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const labels = [soldOut, unavailable].filter(Boolean);
    const suffix = labels.length ? new RegExp(`\\s+-\\s+(?:${labels.join('|')})\\s*$`, 'i') : null;
    const raw = String(option.textContent || option.value || '');
    const base = suffix ? raw.replace(suffix, '').trim() : raw.trim();
    option.dataset.wubBaseLabel = base;
    return base;
  };

  const syncPicker = (picker) => {
    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      const soldOut = input.classList.contains('is-sold-out') && !input.disabled;
      if (input.disabled) {
        input.setAttribute('aria-disabled', 'true');
        input.removeAttribute('aria-label');
      } else if (soldOut && soldOutText()) {
        input.removeAttribute('aria-disabled');
        input.setAttribute('aria-label', `${input.value} — ${soldOutText()}`);
      } else {
        input.removeAttribute('aria-disabled');
        input.removeAttribute('aria-label');
      }
    });

    picker.querySelectorAll('option').forEach((option) => {
      const base = optionBaseText(option);
      const soldOut = option.classList.contains('is-sold-out') && !option.disabled;
      option.textContent = soldOut && soldOutText() ? `${base} - ${soldOutText()}` : base;
      if (option.disabled) option.setAttribute('aria-disabled', 'true');
      else option.removeAttribute('aria-disabled');
    });
  };

  const syncAll = () => {
    document.querySelectorAll('variant-selects, variant-radios').forEach(syncPicker);
  };

  document.addEventListener('wub:product-state-change', syncAll);
  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-selects, variant-radios')) queueMicrotask(syncAll);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  else syncAll();
})();
